<template>
    <v-container fill-height class="mainBackG h-100 loginMain">
            <v-layout row wrap >
              <v-flex class="text-xs-center" xs12 lg4 style="margin:auto">
                    <!--<v-progress-circular :indeterminate="loading" class="ma-0" color="secondary"-->
                                         <!--height="4"></v-progress-circular>-->
                <div class="Formcard pb-5 no-shadow card-r">
                  <v-form v-model="resetPassword" row class="w-100">
                    <v-flex xs12 md12 pt-0 class="pa-0">
                        <v-toolbar flat xs12 class="toolbar pa-0 mb-3">
                            <div  class="pa-0">
                                <router-link to="/login" class="aBtn"><v-icon class="textColor">keyboard_arrow_left</v-icon></router-link>
                            </div>
                            <v-spacer></v-spacer>
                            <v-toolbar-title>
                                <h2 class="textColor text-xs-center title">Reset Password</h2>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items class="hidden-sm-and-down">
                            </v-toolbar-items>
                        </v-toolbar>
                    </v-flex>

                        <v-alert
                                v-if="resetpasswordResponse && resetpasswordMsg"
                                :value="true"
                                color="success"
                                icon="check_circle"
                                outline
                        >
                            {{resetpasswordMsg}}
                        </v-alert>
                        <v-progress-circular
                          v-if="loading"
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                        <v-alert
                                v-if="!resetpasswordResponse && resetpasswordMsg"
                                :value="true"
                                color="error"
                                icon="warning"
                                outline
                        >
                            {{resetpasswordMsg}}
                        </v-alert>
                        <!--<v-flex xs12 md12 pt-0 pb-5>-->
                            <!-- <img class = "logo" src="../../assets/logo.png"/>
                            <h1 class="headline font-weight-medium">Reset password</h1> -->

                        <!--</v-flex>-->
                                <v-layout wrap class="mb-5 pb-5 pt-130">
                                    <!-- <v-flex xs12 md12 class="text-xs-right" py-0 my-0>
                                    </v-flex> -->
                                    <v-flex xs12 sm12>
                                        <!--<p class="text-xs-center f-20 caption font-weight-regulars" >Enter your recovery email</p>-->
                                        <v-text-field
                                                solo
                                                label="Email"
                                                v-model="email" :rules="emailRules" required></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 sm12 pb-0 class="display-grid mt-2">
                                        <v-btn class="text-white ma-0 h-50p mainBackG card-r no-shadow" :disabled="!resetPassword" @click="reset">Confirm</v-btn>
                                    </v-flex>

                                </v-layout>
                        </v-form>
                    </div>

                </v-flex>
            </v-layout>
        </v-container>
</template>

<script>
	/* eslint-disable */
	export default {
		name: "ResetPassword",
		data: () => ({
			resetPassword: false,
      resetpasswordMsg:'',
      resetpasswordResponse:'',
			email: "",
			emailRules: [
				v => !!v || "E-mail is required",
				v => /.+@.+/.test(v) || "E-mail must be valid"
			]
		}),
		methods:{
			reset() {
				this.resetpasswordMsg='';
				var email = this.email;
        this.loading=true
        this.$store.dispatch("resetAccount", email)
        .then((response) => {
						if(response.status=="ok"){
              this.resetpasswordMsg="An email with a verification code was just sent to "+email;
              this.resetpasswordResponse=true
							this.$notify({
								group:"success",
								type: "success",
								text: `Success Check your mail`
							});
							// this.$router.push(`/`);
						}else{
							// error => {
                this.resetpasswordMsg="Check your Mail Address";
                this.resetpasswordResponse=false
								this.$notify({
									group: "error",
									type: "error",
									text: `Enter valid email`
								});
							// }
						}
          },(error)=>{

                this.resetpasswordMsg="Check your Mail Address";
                this.resetpasswordResponse=false
								this.$notify({
									group: "error",
									type: "error",
									text: `Enter valid email`
								});
          })
        setTimeout(() => {
          this.loading=false
        }, 2000);


      }
				// )
    },
		computed:{
        loading:loading => Store.state.loading
		}
	};
</script>
<style>
  .align{
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-box;
  }
  .Formcard{
    height: -webkit-fill-available!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/auth/ResetPassword.vue